export const basePlanCodes = {
  canada_cricket_mo: 'ca-crick_sportsp-mo-v1',
  canada_cricket_qt: 'ca-crick_sportsp-qt-v1',
  canada_cricket_yr: 'ca-crick_sportsp-yr-v1',
  canada_cricket_elite_mo: 'ca-cricket_elite-mo-1',
  canada_cricket_elite_qt: 'ca-cricket_elite-qt-1',
  canada_cricket_elite_yr: 'ca-cricket_elite-yr-1',
  canada_entertainment: 'canada-entertainment',
  canada_essentials: 'canada-essentials',
  canada_premium: 'canada-premium',
  canada_sports_pro_mo: 'ca-sports_pro-mo-1',
  canada_sports_pro_qt: 'ca-sports_pro-qt-1',
  canada_sports_pro_yr: 'ca-sports_pro-yr-1',
  fubo_free: 'fubo_free', // not a plan code, but a channeltag
  canada_mlb_tv: 'ca-mlbtv-mo-1',
  spain_basic: 'spain-basic',
  us_deluxe: 'us-deluxe',
  us_elite: 'us-elite-v2',
  us_essential: 'us-essential-mo-v1',
  us_latino: 'us-latino',
  us_pro: 'us-pro',
  us_zee_family_mo: 'us-willow_zee-mo-1',
  us_zee_family_qt: 'us-willow_zee-qt-1',
  us_fubo_sports_mo: 'us-sports_news-mo-1',
  // us_zee_family_yr: 'us-zee_family-yr-v1',
}
